
import OgorMenu from "@/components/Menu/Menu.vue";
import { Component, MixedVue } from "@/vue";
import { Prop } from "vue-property-decorator";
@Component({
  name: "MenuItem",
  components: {
    OgorMenu,
  },
})
export default class MenuItem extends MixedVue {
  $props!: {
    clickable?: boolean;
    nested?: boolean;
    toggleable?: boolean;
    value?: boolean;
    disabled?: boolean;
    menuStyle?: OgorMenu["menuStyle"];
    placement?: OgorMenu["placement"];
    anchors?: OgorMenu["anchors"];
  };

  $emit!: ((e: "input", value: boolean) => any) & ((e: "click") => any);

  @Prop({ type: Boolean, default: true })
  clickable: boolean;

  @Prop({ type: Boolean, default: false })
  nested: boolean;

  @Prop({ type: Boolean, default: false })
  toggleable: boolean;

  @Prop({ type: Boolean, default: false })
  value: boolean;

  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  @Prop({ type: Object, required: false, default: () => {} })
  menuStyle: OgorMenu["menuStyle"];

  @Prop({ type: String, required: false, default: "bottom-right" })
  placement: OgorMenu["placement"];

  @Prop({ type: String, required: false, default: "start-end" })
  anchors: OgorMenu["anchors"];

  declare $parent: OgorMenu;

  mounted() {
    if (this.clickable || this.toggleable) {
      this.$el.addEventListener("click", this.handleClick);
    }
  }

  beforeDestroy() {
    this.$el.removeEventListener("click", this.handleClick);
  }

  closeMenu() {
    if (this.$parent?.closeMenu) {
      this.$parent.closeMenu();
    }
  }

  handleClick() {
    if (this.nested || this.disabled) return;
    if (this.toggleable) {
      this.$emit("input", !this.value);
    }
    this.closeMenuAndEmit();
  }

  closeMenuAndEmit() {
    this.closeMenu();
    this.$emit("click");
  }
}
